import { Box, Grid, Paper } from "@mui/material";
import BAScreenHeader from "../config/components/BAScreenHeader";
import BAButton from "../config/components/BAButton";
import BAInput from "../config/components/BAInput";
import { useEffect, useState } from "react";
import BAImageUpload from "../config/components/BAImageupload";
import { Get, Post, Put } from "../config/apimethods/apimethods";
import { useParams } from "react-router-dom";
import BAShowError from "../config/components/BAShowerror";

export default function ProductForm() {
    const [model, setModel] = useState({})
    const [showMessage, setShowMessage] = useState(false)
    const [message, setMessage] = useState()

    const params = useParams()

    const fillModel = (key, val) => {
        model[key] = val
        setModel({ ...model })
    }
    const save = () => {
        model.stockInDetail = []
        model.stockOutDetail = []
        model.addedDate = new Date()
        if (params.id) {
            Put('product', model, params.id).then(res => {
                setMessage("Successfully Updated")
                setShowMessage(true)
            }).catch(err => {
                console.log(err.message)
                setMessage(err.message)
                setShowMessage(true)
            })
        } else {
            Post('product', model).then(res => {
                console.log(res.data)
                setMessage("Successfully Saved")
                setShowMessage(true)
            }).catch(err => {
                console.log(err.message)
                setMessage(err.message)
                setShowMessage(true)
            })
        }
    }
    let getProductById = (id) => {
        Get('product', id).then(res => {
            setModel({ ...res.data })
        }).catch(err => {
            setMessage(err.message)
            setShowMessage(true)
        })
    }
    useEffect(() => {
        if (params.id) {
            getProductById(params.id)
        }
    }, [])
    return <>
        <BAShowError message={message} open={showMessage} close={(e) => setShowMessage(e)} />
        <Box>
            <BAScreenHeader title='Product Form' buttonsList={[
                {
                    displayField: <BAButton onClick={save} label='Save' />
                }
            ]} />
            <Paper className="p-2">
                <Grid container>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput value={model.name} onChange={(e) => fillModel('name', e.target.value)} label='Product Name' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput value={model.code} onChange={(e) => fillModel('code', e.target.value)} label='Product Code' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput value={model.category} onChange={(e) => fillModel('category', e.target.value)} label='Product Category' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput value={model.brand} onChange={(e) => fillModel('brand', e.target.value)} label='Product Brand' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput type="number" value={model.price} onChange={(e) => fillModel('price', e.target.value)} label='Product Price' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput type="number" value={model.cost} onChange={(e) => fillModel('cost', e.target.value)} label='Product Cost' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput type="number" value={model.quantityInStock} onChange={(e) => fillModel('quantityInStock', e.target.value)} label='Quantity In Stock' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput value={model.unit} onChange={(e) => fillModel('unit', e.target.value)} label='Unit' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput type='color' value={model.color} onChange={(e) => fillModel('color', e.target.value)} label='Color' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput value={model.pattern} onChange={(e) => fillModel('pattern', e.target.value)} label='Pattern' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput value={model.supplier} onChange={(e) => fillModel('supplier', e.target.value)} label='Supplier' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAImageUpload value={model.image_url} onChange={(e) => fillModel('image_url', e)} />
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        </Box>
    </>
}